/**
 * Type definitions for the Orders domain.
 *
 * Connected to the real backend shape from GET /admin/orders.
 */

export type OrderStatusId = 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 11 | 12 | 13;

export const ORDER_STATUS_LABELS: Record<number, string> = {
  1: 'Esperando recolección',
  2: 'En tránsito a punto',
  3: 'Recibida en punto',
  4: 'Recolectada',
  5: 'Lista para entrega',
  6: 'Entregada',
  8: 'Cancelada',
  10: 'Cancelada por sistema',
  11: 'Por devolver',
  12: 'En espera en punto',
  13: 'Entregada a tercero',
};

/**
 * Groups status IDs for the dashboard metrics header.
 */
export const ORDER_STATUS_GROUPS = {
  por_recibir: [1],
  en_punto: [2, 3, 5, 12],
  recolectadas: [4],
  entregadas: [6, 13],
  por_devolver: [11],
  canceladas: [8, 10],
} as const;

export interface ManualChange {
  changed_at: string;
  responsible: {
    email: string | null;
    name: string | null;
  };
  event_name: string;
  reason: string | null;
  new_status?: number;
  action?: string;
  evidence_gcs_path?: string | null;
}

export interface Order {
  id: string;
  legacy_id: string;
  external_reference: string;
  tracking_number: string | null;
  verification_code: string;
  status: string;
  status_id: number;
  country_code: string;
  tenant_id: string;
  dispatch_place_id: string;
  dispatch_place_name: string;
  order_type: string;
  amount: string; // Decimal as string from backend
  payment_type: string;
  client: Record<string, unknown>;
  shipper: Record<string, unknown>;
  customer_name: string | null;
  currency: string;
  package_count: number;
  collected_at: string | null;
  delivered_at: string | null;
  created_at: string;
  updated_at: string;
  // Auditing / Soft-delete fields
  deleted?: boolean;
  deleted_at?: string | null;
  deleted_reason?: string | null;
  manual_changes?: ManualChange[];
}

export interface OrderMetrics {
  total: number;
  by_status: { status_id: number; count: number }[];
}

export interface OrderListResponse {
  items: Order[];
  total: number;
  page: number;
}

export type OrderSortBy = 'created_at' | 'updated_at' | 'status_id';
export type OrderSortOrder = 'asc' | 'desc';
export type OrderSearchField = 'todos' | 'guia' | 'cliente' | 'punto' | 'referencia';

export interface OrderListFilters {
  search?: string;
  search_field?: OrderSearchField;
  sort_by?: OrderSortBy;
  sort_order?: OrderSortOrder;
  status?: number;
  page?: number;
  limit?: number;
  from?: string;
  to?: string;
  deleted?: boolean;
}

export interface BlockedOrder {
  ref: string;
  reason: 'not_cancellable' | 'sot_unavailable' | string;
  current_status: number | string;
  status_name?: string;
}

export interface ChangeStatusResponse {
  updated: string[];
  blocked: BlockedOrder[];
  not_found: string[];
}

export interface EvidenceSignedUrlResponse {
  upload_url: string;
  gcs_path: string;
}
